import React from 'react';
import { Inline, Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import { Touchable } from '../../../ui';
import { BasicMailIcon } from '../../../ui/Icons/BasicMailIcon';
import { SymbolsTwitterCircleIcon } from '../../../ui/Icons/SymbolsTwitterCircleIcon';
import { SymbolsFacebookCircleIcon } from '../../../ui/Icons/SymbolsFacebookCircleIcon';
import { ChattingCommentTextIcon } from '../../../ui/Icons/ChattingCommentTextIcon';
import {
  getAndroidVersion,
  getIOSVersion,
  getIsApp,
} from '../../../../modules/AppInfo';
import { ShareOptions } from '../types';

type SocialLinksProps = {
  shareOptions: ShareOptions[];
  onShare: (event: { type: ShareOptions }) => void;
};

const SocialLinks: React.FCWithChildren<SocialLinksProps> = ({
  shareOptions,
  onShare,
}) => (
  <Inline space={16} alignItems="center">
    {!!shareOptions.includes('facebook') && (
      <Touchable onClick={() => onShare({ type: 'facebook' })}>
        <Box
          justifyContent="center"
          alignItems="center"
        >
          <SymbolsFacebookCircleIcon
            color={colors.blackInBlack}
            width={34}
            height={34}
          />
        </Box>
      </Touchable>
    )}
    {!!shareOptions.includes('twitter') && (
      <Touchable onClick={() => onShare({ type: 'twitter' })}>
        <Box
          justifyContent="center"
          alignItems="center"
        >
          <SymbolsTwitterCircleIcon
            width={34}
            height={34}
          />
        </Box>
      </Touchable>
    )}
    {!!shareOptions.includes('email') && (
      <Touchable onClick={() => onShare({ type: 'email' })}>
        <Box
          color={colors.blackInBlack}
          minWidth={34}
          minHeight={34}
          borderRadius={17}
          justifyContent="center"
          alignItems="center"
        >
          <BasicMailIcon
            color={colors.whiteWash}
            height={20}
            width={20}
          />
        </Box>
      </Touchable>
    )}
    {(!!shareOptions.includes('sms') && (getIsApp() || getAndroidVersion() || getIOSVersion())) && (
      <Touchable onClick={() => onShare({ type: 'sms' })}>
        <Box
          color={colors.blackInBlack}
          minWidth={34}
          minHeight={34}
          borderRadius={17}
          justifyContent="center"
          alignItems="center"
        >
          <ChattingCommentTextIcon
            color={colors.whiteWash}
            height={20}
            width={20}
          />
        </Box>
      </Touchable>
    )}
  </Inline>
);

export default SocialLinks;
